// extracted by css-extract-rspack-plugin
export default {"cls1":"WinBackPing-cls1_fwc","cls2":"WinBackPing-cls2_aP7 WinBackPing-cls1_fwc"};